<template>
	<div class="work-order">
		<el-form label-width="90px" :model="model" :rules="addRules" ref="form">
			<el-form-item label="手机号码：" prop="phone">
				<el-input v-model="model.phone" size="mini"></el-input>
			</el-form-item>
			<el-form-item label="订单号：" prop="outId">
				<el-input v-model="model.outId" size="mini"></el-input>
			</el-form-item>
			<el-form-item label="备注：" prop="describe">
				<el-input v-model="model.describe" type="textarea"></el-input>
			</el-form-item>
			<el-form-item label="收花日：" prop="recievedDate">
				<el-date-picker v-model="model.recievedDate" type="date" placeholder="选择日期" size="mini" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
			</el-form-item>
			<el-form-item label="问题分类：" prop="question">
				<el-cascader :options="questionList" :props="props" v-model="model.question" @change="handleChange" size="mini"></el-cascader>
			</el-form-item>
			<el-form-item label="图片：">
				<a v-for="(item, index) in model.picList" class="img-box js-workorder-img-box" href="javascript:;" :style="'background-image: url(' + item + ')'">
					<img :src="item">
					<span class="del-btn" @click="delImg(index)">×</span>
				</a>
				<label class="upload-button">
					<span class="jia">+</span>
					<input type="file" accept="image/*" @change="uploadImg">
				</label>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="mini" @click="submitWorkOrder">创建工单</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'huajiaWorkOrder',
	data () {
		return {
			questionList: [],
			props: {
				value: 'id',
				label: 'name'
			},
			model: {
				phone: '',
				outId: '',
				describe: '',
				recievedDate: '',
				question: [],
				quesid: '',
				secquesid: '',
				picList: []
			},
			addRules: {
				phone: [
					{required: true, validator: this.checkTel, trigger: 'blur'}
				],
				outId: [
					{required: true, message: '请输入订单号', trigger: 'blur'}
				],
				describe: [
					{required: true, message: '请输入备注信息', trigger: 'blur'}
				],
				recievedDate: [
					{required: true, message: '请选择日期', trigger: 'change'}
				],
				question: [
					{required: true, message: '请选择问题分类', trigger: 'change'}
				]
			}
		}
	},
	computed: {
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	mounted () {
		var self = this;
		self.getQuestionList();
		$(document).on('click', '.js-workorder-img-box img', function() {
			TJ_IM.zoomImImg($(this));
		});
	},
	methods: {
		// 手机号验证
		checkTel(rule, value, callback) {
			if (!value) {
				callback(new Error('请输入电话号码'));
			} else if (!/^(1)\d{10}$/.test(value)) {
				callback(new Error('手机号码有误'));
			} else {
				callback();
			}
		},

		// 选择问题类型
		handleChange(value) {
			var self = this;

			if (!!value[0]) self.model.quesid = value[0];
			if (!!value[1]) self.model.secquesid = value[1];
		},

		// 获取问题分类列表
		getQuestionList () {
			var self = this;

			self.$axios.post(API_ROOT.uploadUrl + '/raw/flowerplus/get_ticket_types').then(result => {
				self.questionList = result;
			}, response => {
				self.$alert('获取问题分类列表失败，错误码(' + response + ')');
			})
		},

		// 上传图片
		uploadImg(e) {
			var self = this,
				uploadUrl = API_ROOT.uploadUrl + '/raw/img/qiniuToken';

			if (!e.target.value) return;
			TJ_IM.uploadLocalImgFile(uploadUrl, e.target.files[0], function(src) {
				e.target.value = '';
				if (src) {
					self.model.picList.push(src);
				} else {
					self.$alert('上传图片失败！');
				}
			});
		},

		// 删除上传的图片
		delImg (index) {
			var self = this;

			self.model.picList.splice(index, 1);
		},

		// 提交工单
		submitWorkOrder () {
			var self = this,
				data = {
					describe: self.model.describe,
					openid: self.currentConversation.clientid,
					outId: self.model.outId,
					out_pics: self.model.picList,
					phone: self.model.phone,
					quesid: self.model.quesid,
					recievedDate: self.model.recievedDate,
					secquesid: self.model.secquesid,
					sessionId: self.currentConversation.id
				};

			var newData = "";
			for(var i in data){
				newData += i + "=" + data[i] + "&";
			}
			newData = newData.substring(0, newData.length - 1);

			self.$refs['form'].validate((valid) => {
				if (!valid) return;

				self.$axios.request({
					url : API_ROOT.uploadUrl + '/raw/flowerplus/saveComment', 
					data : newData,
					headers: {'Content-Type': 'application/x-www-form-urlencoded'},
					method: 'post'
				}).then(result => {
					self.$alert(result.msg);
					if (result.status) {
						try {
						self.$refs['form'].resetFields();
						} catch(e) {}
					}
				}, response => {
					self.$alert('创建工单失败，错误码(' + response + ')');
				})
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/huajiaWorkOrder.vue